import { render, staticRenderFns } from "./FAQAdd.vue?vue&type=template&id=35c8c0d4&scoped=true&"
import script from "./FAQAdd.vue?vue&type=script&lang=js&"
export * from "./FAQAdd.vue?vue&type=script&lang=js&"
import style0 from "./FAQAdd.vue?vue&type=style&index=0&id=35c8c0d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c8c0d4",
  null
  
)

export default component.exports